var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7656 5.4344L10.5656 0.2344C10.4152 0.084 10.212 0 10 0H1.6C0.716 0 0 0.716 0 1.6V19.2C0 20.084 0.716 20.8 1.6 20.8H14.4C15.284 20.8 16 20.084 16 19.2V6C16 5.788 15.916 5.5848 15.7656 5.4344ZM10.4 15.2H4C3.5584 15.2 3.2 14.8416 3.2 14.4C3.2 13.9584 3.5584 13.6 4 13.6H10.4C10.8416 13.6 11.2 13.9584 11.2 14.4C11.2 14.8416 10.8416 15.2 10.4 15.2ZM12 12H4C3.5584 12 3.2 11.6416 3.2 11.2C3.2 10.7584 3.5584 10.4 4 10.4H12C12.4416 10.4 12.8 10.7584 12.8 11.2C12.8 11.6416 12.4416 12 12 12ZM10.4 6.4C9.9584 6.4 9.6 6.0416 9.6 5.6V1.5232L14.4768 6.4H10.4Z",
    fill: "#2E76CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file_icon.fbc333bd6f8b087dc512d724e9f44540.svg";
export { ForwardRef as ReactComponent };